import React, { ReactNode } from 'react';
import AntTabs, { TabsProps as AntTabsProps } from 'antd/lib/tabs';
import styled from 'styled-components';
import { FixMe } from '@utils/types';
import { Card } from '../card';
import { StyledTabs } from './styles';

interface TabItem {
  title: string;
  key?: string;
  component: React.ComponentType<FixMe>;
}

interface TabsProps extends AntTabsProps {
  tabs: TabItem[];
}

const { TabPane } = AntTabs;
export const CardTabs = ({ tabs, ...antTabsProps }: TabsProps) => (
  <AntTabs tabBarStyle={{ paddingLeft: 28 }} defaultActiveKey="0" {...antTabsProps}>
    {tabs.map(({ title, key, component: Component }, i) => (
      <TabPane tab={title} key={key || i.toString()}>
        <Card>
          <Component />
        </Card>
      </TabPane>
    ))}
  </AntTabs>
);

export const Tabs = styled(AntTabs)`
  .ant-tabs-tab {
    padding-left: 10px;
    padding-right: 10px;
  }

  .ant-tabs-content-holder {
    display: flex;
  }
  .ant-tabs-content {
    //height: 100%;
  }
  height: 100%;
`;

interface Props {
  items: { title: string; key: string }[];
  activeKey?: string;
  onChange: (val: string) => void;
  content: ReactNode;
}

export const TabsV1 = ({ items, onChange, activeKey, content }: Props) => (
  <StyledTabs onChange={onChange} activeKey={activeKey}>
    {items.map((item) => (
      <TabPane tab={item.title} key={item.key}>
        {activeKey === item.key ? content : null}
      </TabPane>
    ))}
  </StyledTabs>
);
